import styled from '@themes/theme'

export const BannerButtonWrap = styled.div`
  z-index: 1;
  width: 100%;
  height: auto;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-content: flex-start;
  flex-wrap: wrap;
  backdrop-filter: blur(35px);
  -webkit-backdrop-filter: blur(35px);
  background: #1c202b4D;
  > p {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 26px;
    color: #FFFFFF99;
    font-size: ${props => props.theme.font.small};
    font-weight: ${props => props.theme.fontW.regular};
    transform: translateY(1px);
    position: relative;
    ::before {
      content: '';
      display: block;
      position: absolute;
      top: -17px;
      background:linear-gradient(to bottom, #00000000, #00000026);
      width: 100%;
      height: 16px;
    }
  }
  .link-btn {
    width: auto;
    height: 44px;
    max-width: 160px;
    flex: 1;
    margin-bottom: 14px;
    > img {
      width: auto;
      height: 100%;
    }
  }
  &.pc {
    transform: translate(-50%, 1px);
    > p {
      height: 30px;
      font-size: ${props => props.theme.font.medium};
      transform: translateY(3px);
    }
  }
`
